// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"bbb99a2f","634":"4019459c"}[chunkId] + ".chunk.js";
};